;
(function (ng) {
  'use strict';

  angular.module('windowExt', []);
})(angular);